const ChevronIcon = () => (`<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 8 8" fill="currentColor"><polygon points="4,6 1.2,3.3 1.8,2.7 4,5 6.2,2.7 6.8,3.3"/>
</svg>`);
export default ChevronIcon;
